import './app/publicPath'

const Vue = window.Vue

Vue.component('FsLiveShopping', () => import('./app/components/FsLiveShopping.vue'))
Vue.component('FsSingleItem', () => import('./app/components/item/FsSingleItem.vue'))
